import { SegmentService } from './segment-generated';

const Analytics = new SegmentService();
Analytics.load();

export { Analytics as SegmentService };
